import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import AboutUs from "../../features/about-us/AboutUs";
import Login from "../../features/authentication/login/Login";
import Register from "../../features/authentication/register/Register";
import Home from "../../features/home/Home";
import Playground from "../../features/playground/Playground";
import SchoolView from "../../features/school/SchoolView";
import VacancyDetails from "../../features/school/VacancyDetails";
import TeacherView from "../../features/teacher/TeacherView";
import HomeLayout from "../../layouts/HomeLayout";
import NoNavLayout from "../../layouts/NoNavLayout";
import PrivateRoute from "../wrappers/PrivateRoute";
import { PERMISSIONS } from "../../auth/permissions";
import TeacherAbsencesView from "../../features/teacher/TeacherAbsencesView";
import { VacanciesProvider } from "../../states/vacancy-state/vacancy.state";
import VacancyCreate from "../../features/school/VacancyCreate";
import TeacherOverview from "../../features/teacher-overview/TeacherOverview";
import VacancyUpdate from "../../features/school/VacancyUpdate";

const appRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about-us" element={<AboutUs />}></Route>
        <Route
          path="/school"
          element={
            <PrivateRoute permissions={[PERMISSIONS.CanViewSchoolArea]}>
              <VacanciesProvider>
                <SchoolView />
              </VacanciesProvider>
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="vacancy"
          element={
            <PrivateRoute>
              <VacancyCreate />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="vacancy/:id"
          element={
            <PrivateRoute>
              <VacancyDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="vacancy/:id/update"
          element={
            <PrivateRoute permissions={[PERMISSIONS.CanUpdateVacancy]}>
              <VacancyUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/teacher"
          element={
            <PrivateRoute permissions={[PERMISSIONS.CanViewTeacherArea]}>
              <VacanciesProvider key="teacher">
                <TeacherView />
              </VacanciesProvider>
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/absences"
          element={
            <PrivateRoute permissions={[PERMISSIONS.CanViewTeacherArea]}>
              <VacanciesProvider key="absences">
                <TeacherAbsencesView />
              </VacanciesProvider>
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="teacher-overview"
          element={
            <PrivateRoute permissions={[PERMISSIONS.CanViewSchoolArea]}>
              <TeacherOverview />
            </PrivateRoute>
          }
        />
        <Route path="/playground" element={<Playground />}></Route>
      </Route>
      <Route element={<NoNavLayout />}>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
      </Route>
    </>,
  ),
);

export default appRouter;
